var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"uk-alert uk-alert-warning dcs-alert"},[_c('content-section',{attrs:{"content-key":_vm.errorType,"law":_vm.law,"brand":_vm.brand}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }